// App.js
import "./App.css";
import React from "react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import AuthShop from "./components/app/authShop";
import Home from "./components/app/home";
import Login from "./components/app/login";
import OrderWrapper from "./components/wrappers/OrderWrapper";
import OuterWrapper from "./components/wrappers/OuterWrapper";
import PopupLanding from "./components/app/popupLanding";
import PopupOrder from "./components/app/popupOrder";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/start/id/:orderReferenceId",
    element: <AuthShop />,
  },
  {
    path: "/shop-return/:orderReferenceId",
    element: <OrderWrapper />,
  },
  {
    path: "/popup-landing/:orderReferenceId",
    element: <PopupLanding />,
  },
  {
    path: "/popup-return/:orderReferenceId",
    element: <PopupOrder />,
  },
]);

class App extends React.Component {
  render = () => {
    return (
      <OuterWrapper>
        <React.Fragment>
          <RouterProvider router={router} />
        </React.Fragment>
      </OuterWrapper>
    );
  };
}

export default App;
